import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { Esteira } from 'app/main/content/shared/models/esteira.model';
import { Plano } from 'app/main/content/shared/models/plano.model';
import { EsteiraService } from 'app/main/content/shared/services/esteira.service';
import { PlanoService } from 'app/main/content/shared/services/plano.service';
import { ProcessoService } from 'app/main/content/shared/services/processo.service';
import { WebProcessoControleService } from 'app/main/content/shared/services/webProcessoControle.service';
import { LoginStore } from 'app/main/content/shared/store/login.store';
import { ModalMensagemComponent } from '../modal-mensagem/modal-mensagem/modal-mensagem.component';
import { WebModulosTextosService } from 'app/main/content/shared/services/webModulosTextos.service';
import { WebModulosTextos } from 'app/main/content/shared/models/webModulosTextos.model';
import { environment } from 'environments/environment';
import { ViewModelDadosModulos } from 'app/main/content/shared/models/ViewModelDadosModulos.model';
import { ViewModelDadosInstitutos } from 'app/main/content/shared/models/ViewModelDadosInstitutos.model';
import { ViewModelFiltroWebModulosTextos } from 'app/main/content/shared/models/viewModelFiltroWebModulosTextos.model';
import { WebModulos } from 'app/main/content/shared/models/WebModulos.model';
import { WebInstitutos } from 'app/main/content/shared/models/WebInstitutos.model';
import { ViewModelProcessoWebModulosTextos } from 'app/main/content/shared/models/ViewModelProcessoWebModulosTextos.model';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';


//import Swal from 'sweetalert2';

export interface Food {
    value: string;
    viewValue: string;
}
@Component({
    selector: 'app-cadastrar-mensagem-modulo',
    templateUrl: './cadastrar-mensagem-modulo.component.html',
    styleUrls: ['./cadastrar-mensagem-modulo.component.scss']
})
export class CadastrarMensagemModuloComponent implements OnInit {
    [x: string]: any;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    webModulosTextos: WebModulosTextos = new WebModulosTextos();
    lista_Modulo: ViewModelDadosModulos[] = [];
    lista_Instituto: ViewModelDadosInstitutos[] = [];
    lista_Plano: Plano[] = [];
    displayedColumns: string[] = ['nmModulos', 'nmPlano', 'nmInstitutos', 'nmTexto', 'alterar', 'excluir'];
    selection = new SelectionModel<any>(true, []);
    dataSource = new MatTableDataSource<any>();
    loading = false;
    selectedModulo: number;
    selectedPlano: number;
    selectedInstituto: number;
    dataInicio: string;
    dataFim: string;
    idPessoaLogada: number;
    ListaIdPessoa: number[];
    isDateFormat: boolean = environment.isDateFormat;
    viewModelFiltroWebModulosTextos: ViewModelFiltroWebModulosTextos = new ViewModelFiltroWebModulosTextos();
    //viewModelFiltroWebModulosTextosTABELA :ViewModelFiltroWebModulosTextos[] = [];
    viewModelProcessoWebModulosTextos: ViewModelProcessoWebModulosTextos = new ViewModelProcessoWebModulosTextos();
    nmTexto: string = '';

    nrCpf: string;
    constructor(
        private planoService: PlanoService,
        private webModulosTextosService: WebModulosTextosService,
        private loginStore: LoginStore,
        private dialog: MatDialog,
        private _snackBar: MatSnackBar,
    ) {

    }

    ngOnInit() {
        this.loginStore.getCurrent().subscribe(retorno => {
            this.idPessoaLogada = retorno.idPessoa;
        });

        this.dataSource.paginator = this.paginator;

        this.loadPlano();
        this.loadInstituto();
        this.loadModulo();

        // let obj = JSON.parse(localStorage.getItem('search'));

        // if (obj != null) {
        //     this.selectedProcesso = obj.selectedProcesso;
        //     this.selectedSituacao = obj.selectedSituacao;
        //     this.selectedPlano = obj.selectedPlano;
        //     this.dataInicio = obj.dataInicio;
        //     this.dataFim = obj.dataFim;
        //     this.selectedOrderBy = obj.selectedOrderBy;
        //     // this.cpf = obj.cpf;
        //     // this.applyFilter(obj.cpf);
        //     this.filtroBuscaAdesao();
        // }

    }

    openModal(viewModelProcessoWebModulosTextos: ViewModelProcessoWebModulosTextos | null) {
        const isEdicao = !!viewModelProcessoWebModulosTextos;

        const dialogRef = this.dialog.open(ModalMensagemComponent, {
            width: "90vw",
            height: "80vh",
            maxWidth: "1200px",
            maxHeight: "600px",
            data: {
                modo: isEdicao ? 'editar' : 'novo',
                objeto: viewModelProcessoWebModulosTextos
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'sucesso') {
                this.preencheTabela();
            }
        });
    }
    openModal2(element) {
        const isEdicao = !!element;
        if(isEdicao && element){
            const elemento = {...element};
        
            if(element.idPlano === 0 && element.nmPlano){
                const planoIdentificado = this.lista_Plano.find(p => p.nmPlano === element.nmPlano);
                if(planoIdentificado){
                elemento.idPlano = planoIdentificado.idPlano; 
                }
            }

            if(element.idInstitutos === 0 && element.nmInstitutos){
                const instIdentificado = this.lista_Instituto.find(p => p.nmInstitutos === element.nmInstitutos);
                if(instIdentificado){
                    elemento.idInstitutos = instIdentificado.idInstitutos; 
                }
            }

            if(element.idModulos === 0 && element.nmModulos){
                const moduloIdentificado = this.lista_Modulo.find(p => p.nmModulos === element.nmModulos);
                if(moduloIdentificado){
                elemento.idModulos = moduloIdentificado.idModulos; 
                }
        }
        const dialogRef = this.dialog.open(ModalMensagemComponent, {
            width: "90vw",
            height: "80vh",
            maxWidth: "1200px",
            maxHeight: "600px",
            data: {
                modo: 'editar',
                objeto: elemento,
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'sucesso') {
                this.preencheTabela();
            }
        });

        }
        
    }

    loadPlano() {
    this.planoService.getAll().subscribe(plano => {
        this.lista_Plano = plano
            .filter(p => p.idPlano !== 0)
            .sort((a, b) => a.idPlano - b.idPlano);
    });
    }

    loadInstituto() {
    this.webModulosTextosService.RetornaListaComboInstitutosService().subscribe((instituto) => {
        this.lista_Instituto = instituto.sort((a, b) => a.idInstitutos - b.idInstitutos);
        this.lista_Instituto_Modulo = [...this.lista_Instituto];
    });
    }


    onModuloChange() {
    this.updateInstitutos();
    }

    onPlanoChange() {
    this.updateInstitutos();
    }

    updateInstitutos() {
        const modulo = this.selectedModulo || 0;
        const plano = this.selectedPlano || 0;

        this.loadInstitutoPorModuloEPlano(modulo, plano);
        this.selectedInstituto = null;

    }



    loadInstitutoPorModuloEPlano(idModulo: number,idPlano: number) {
             this.webModulosTextosService.RetornaListaFiltroInstitudo(idModulo, idPlano).subscribe(
                (institutos) => {
                    this.lista_Instituto_Modulo = institutos;
                },
                (error) => {
                    this.list_Instituto_Modulo = [...this.lista_Instituto]
                }
            );
    }

    excluir(idSeq: number) {
    Swal.fire({
        title: 'Confirmar exclusão',
        text: 'Você tem certeza que deseja excluir este registro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sim, excluir',
        cancelButtonText: 'Cancelar',
        width: '500px',
        padding: '1.3rem',
        customClass: {
            popup: 'modal-alerta'
        }
    }).then((result) => {

        if (!result.isConfirmed) {
            return; 
        }

        this.loading = true;

        this.webModulosTextosService.excluir(idSeq).subscribe(
            retorno => {
                this.loading = false;
                this.openSnackBar('Registro excluído com sucesso', "X");
                this.preencheTabela();
            },
            error => {
                this.loading = false;
                this.openSnackBarError('Erro ao excluir o registro', "X");
            }
        );
    });

}



    loadModulo() {
    this.webModulosTextosService.RetornaListaComboModulos().subscribe(modulo => {
        this.lista_Modulo = modulo.sort((a, b) => a.idModulos - b.idModulos);
    });
}

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }


    // /** Selects all rows if they are not all selected; otherwise clear selection. */
    // masterToggle() {
    //     this.isAllSelected() ?
    //         this.selection.clear() :
    //         this.dataSource.data.forEach(row => this.selection.select(row));
    // }


    clear() {
        this.selectedProcesso = undefined;
        this.selectedSituacao = undefined;
        this.selectedPlano = undefined;
        this.dataInicio = undefined;
        this.dataFim = undefined;
        this.selectedModulo = undefined;
        this.selectedInstituto = undefined;
        //this.selectedOrderBy = undefined;
    }
    preencheTabela() {
        this.loading = true;

        this.viewModelFiltroWebModulosTextos.idModulos = this.selectedModulo || 0;
        this.viewModelFiltroWebModulosTextos.idInstitutos = this.selectedInstituto || 0;
        this.viewModelFiltroWebModulosTextos.idPlano = this.selectedPlano || 0;
        this.viewModelFiltroWebModulosTextos.idSeq = 0;
        this.viewModelFiltroWebModulosTextos.nmTexto = "";

        this.webModulosTextosService.PostFiltroDesligados(this.viewModelFiltroWebModulosTextos).subscribe(tabela => {
            //console.log('TESTE DA TABELA', tabela);
            this.viewModelProcessoWebModulosTextos = tabela['data']
            //console.log("variavel da TABela", this.viewModelProcessoWebModulosTextos)
            this.dataSource = new MatTableDataSource<ViewModelProcessoWebModulosTextos>(tabela);
            this.dataSource.paginator = this.paginator;

            this.loading = false;


        }, error => {
            this.openSnackBarError("Erro ao realizar a busca!" + error.error, 'X');
            this.loading = false;

        });



    }

    // filtroBuscaAdesao() {
    //     // FILTRO ADESÃO
    //     this.loading = true;
    //     this.PostFiltro.idProcesso = this.selectedProcesso;
    //     this.PostFiltro.idStatus = this.selectedSituacao;
    //     this.PostFiltro.idPlano = this.selectedPlano;
    //     this.PostFiltro.dtInicio = this.dataInicio;
    //     this.PostFiltro.dtFim = this.dataFim;
    //     // this.PostFiltro.selectedOrderBy = this.selectedOrderBy;

    //     this.cpf = undefined;


    //     this.webProcessoControleService.FiltraProcesso(this.PostFiltro).subscribe(solicitacoes => {
    //         if (solicitacoes) {
    //             console.log(solicitacoes);
    //             this.dataSource = new MatTableDataSource<>(solicitacoes);
    //             this.dataSource.paginator = this.paginator;

    //             this.loading = false;
    //         }

    //     }, error => {
    //         this.openSnackBarError("Erro ao realizar a busca!" + error.error, 'X');
    //         this.loading = false;
    //     });

    // }



    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ['mat-toolbar', 'mat-success']
        });
    }

    openSnackBarError(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 20000,
            panelClass: ['mat-toolbar', 'mat-warn']
        });
    }


}



